<template>
  <div>
    <div id="digital-flop" style="margin-left: 200px">
      <div
        class="digital-flop-item"
        v-for="item in digitalFlopData"
        :key="item.title"
      >
        <dv-border-box-1>
          <div class="digital-flop-title">
            <span class="digital-flop-title_unit">
              {{ item.title1 }}
            </span>
            <span class="digital-flop-title_unit">
              {{ item.title2 }}
            </span>
          </div>

          <div class="digital-flop">
            <dv-digital-flop
              :config="item.number"
              style="width: 50%; height: 70px"
            />
            <div
              class="no_warning"
              :style="{ color: item.warnings > 0 ? '#f46827' : '#4d99fc' }"
            >
              {{ item.warnings }}
            </div>
          </div>
        </dv-border-box-1>
      </div>
      <!-- <dv-decoration-10 /> -->
    </div>
  </div>
</template>

<script>
import { Url } from "../config/env";
import { welcome_title_data } from "../api/getData";
import Float_menu from "../views/Float_menu";

export default {
  name: "Welcome_page_title",
  data() {
    return {
      titleData: {},
      digitalFlopData: [],
      baseUrl: Url,
    };
  },
  components: {
    Float_menu,
  },
  methods: {
    //更新页面数据
    async refreshTitleData() {
      //获取主题数据
    },

    async createData() {
      // const { randomExtend } = this;
      this.titleData = await welcome_title_data();
      this.digitalFlopData = [
        {
          title1: "服务器",
          title2: "告警",
          number: {
            number: [this.titleData.data.data.title_data.服务器.amount],
            content: "{nt}",
            // textAlign: "right",
            style: {
              fill: "#4d99fc",
              fontWeight: "bold",
              fontFamily: "'黑体', 'SimHei', 'sans-serif'",
            },
          },
          warnings: this.titleData.data.data.title_data.服务器.problem_qty,
        },
        {
          title1: "交换机",
          title2: "告警",
          number: {
            number: [this.titleData.data.data.title_data.交换机.amount],
            content: "{nt}",
            // textAlign: "right",
            style: {
              fill: "#4d99fc",
              fontWeight: "bold",
              fontFamily: "'黑体', 'SimHei', 'sans-serif'",
            },
          },
          warnings: this.titleData.data.data.title_data.交换机.problem_qty,
        },
        {
          title1: "存储",
          title2: "告警",
          number: {
            number: [this.titleData.data.data.title_data.存储.amount],
            content: "{nt}",
            // textAlign: "right",
            style: {
              fill: "#4d99fc",
              fontWeight: "bold",
              fontFamily: "'黑体', 'SimHei', 'sans-serif'",
            },
          },
          warnings: this.titleData.data.data.title_data.存储.problem_qty,
        },
        {
          title1: "虚拟机",
          title2: "告警",
          number: {
            number: [this.titleData.data.data.title_data.虚拟机.amount],
            content: "{nt}",
            // textAlign: "right",
            style: {
              fill: "#4d99fc",
              fontWeight: "bold",
              fontFamily: "'黑体', 'SimHei', 'sans-serif'",
            },
          },
          warnings: this.titleData.data.data.title_data.虚拟机.problem_qty,
        },
        {
          title1: "数据库",
          title2: "告警",
          number: {
            number: [this.titleData.data.data.title_data.数据库.amount],
            content: "{nt}",
            // textAlign: "right",
            style: {
              fill: "#4d99fc",
              fontWeight: "bold",
              fontFamily: "'黑体', 'SimHei', 'sans-serif'",
            },
          },
          warnings: this.titleData.data.data.title_data.数据库.problem_qty,
        },
        {
          title1: "环控终端",
          title2: "告警",
          fontFamily: "'黑体', 'SimHei', 'sans-serif'",

          number: {
            number: [this.titleData.data.data.title_data.机房环控.amount],
            content: "{nt}",
            // textAlign: "right",
            style: {
              fill: "#4d99fc",
              fontWeight: "bold",
              fontFamily: "'黑体', 'SimHei', 'sans-serif'",
            },
          },
          warnings: this.titleData.data.data.title_data.机房环控.problem_qty,
        },
      ];
    },
    // randomExtend(minNum, maxNum) {
    //   if (arguments.length === 1) {
    //     return parseInt(Math.random() * minNum + 1, 10);
    //   } else {
    //     return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
    //   }
    // },
  },
  mounted() {
    // const { createData } = this;
    this.createData();
    setInterval(this.createData, 60000);
  },
};
</script>

<style lang="less">
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
// .el-icon-arrow-down {
//   font-size: 12px;
// }
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
#digital-flop {
  position: relative;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #111217;

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 16%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // border-left: 3px solid rgb(6, 30, 93);
    // border-right: 3px solid rgb(6, 30, 93);
  }

  .digital-flop-title {
    font-size: 24px;
    margin-top: 10%;
    color: #fff;
    text-align: center;
    display: flex;
  }

  .digital-flop-title_unit {
    width: 50%;
    height: 40px;
    // float: right;
  }

  .digital-flop {
    display: flex;
  }
  .no_warning {
    width: 50%;
    height: 100%;
    color: #4d99fc;
    font-size: 28px;
    font-family: "黑体", "SimHei", sans-serif;
    font-weight: bold;
    transform: translate(45%, 60%);
  }
}
</style>
